import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import React from 'react';
import StackingCard from '../../components/CardStack/Card/StackingCard';
import styles from './styles';
export const Header = ({ title, subtitle }) => {
    return title ? (_jsx(StackingCard, { lvl: 2, children: _jsx(Box, { sx: styles.cardHeader, children: _jsxs(Box, { sx: { flex: '1' }, children: [title && (_jsx(Typography, { variant: 'h1', sx: { mt: '1rem' }, children: title })), subtitle && (_jsx(Box, { sx: styles.subtitle, children: _jsx(Box, { children: _jsx(Typography, { variant: 'subtitle1', children: subtitle }) }) }))] }) }) })) : (_jsx(_Fragment, {}));
};
